<template>
	<PayUnlockShell v-bind="shellProps" @select="$emit('select')">
		<template #left>
			<PayIcon icon="pack" color="#fff" :bg="btnColor" :h5="h5" />
		</template>
		<template #info>
			<p class="g-block-pay-unlock__title">{{ data.title || '包含 96 份文档资料' }}</p>
			<p class="g-block-pay-unlock__desc">{{ data.subtitle || '资料大小2.35GB' }}</p>
			<div class="g-block-pay-unlock__prices">
				<span class="g-block-pay-unlock__price" :style="priceColor">¥ {{ displayPrice }}</span>
			</div>
		</template>
		<template #action>
			<PayUnlockButton
				:text="data.buttonText || '获取下载权限'"
				:style="buttonStyle"
				@click="onButtonClick"
			/>
		</template>
	</PayUnlockShell>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import PayUnlockButton from '../shared/PayUnlockButton.vue';
	import PayIcon from '../shared/PayIcon.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { DEFAULT_PAY_UNLOCK_PACK } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockPack',
		components: { PayUnlockShell, PayUnlockButton, PayIcon },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_PACK;
			},
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_PACK);
			},
			priceColor() {
				return { color: this.btnColor };
			},
			shellProps() {
				return {
					data: this.data,
					editable: this.editable,
					active: this.active,
					fixedBottom: this.fixedBottom,
					h5: this.h5,
				};
			},
			displayPrice() {
				return formatPayPrice(this.data.price);
			},
		},
	};
</script>
